<template>
	<div class="time">
		<p>链接有效期倒计时：<span>{{ countdownTime }}</span></p>
	</div>
</template>
 
<script>
import moment from 'moment';
export default {
	name: "Time",
	props: ['endtime'],
	data() {
		return {
			countdownTime: '',
			timer: '',
		};
	},
	mounted() {
		
		this.timer = setInterval(() => {
			if (this.endtime) {
				// console.log(typeof(this.endtime));
				
				let time2 = moment(this.endtime);
				// console.log(time2)
				this.countdownTime = this.countdown(new Date().getTime(), Date.parse(time2))
			}
		}, 1000)
	},
	methods: {
		// 获取倒计时
		countdown(time1, time2) {
			// console.log(time1,time2)
			let time3 = time1 - time2;
			let day = Math.trunc(time3 / 86400000);
			let time4 = time3 % 86400000
			let hour = Math.trunc(time4 / 3600000);
			let time5 = time4 % 3600000;
			let minute = Math.trunc(time5 / 60000);
			let time6 = time5 % 60000
			let second = Math.round(time6 / 1000);
			if (day != 0) {
				return day + '天 : ' + hour + '时 : ' + minute + '分 : ' + second + '秒'
			} else {
				if (day == 0 && hour != 0) {
					return hour + '时 : ' + minute + '分 : ' + second + '秒'
				} else if (day == 0 && hour == 0 && minute != 0) {
					return minute + '分 : ' + second + '秒'
				} else if (day == 0 && hour == 0 && minute == 0) {
					return second + '秒'
				}
			}
		}
	},
};
</script>
 
<style scoped lang="scss">
.time {
	width: 100%;
	height: 40px;
	background-color: #FFF5ED;

	p {
		text-align: center;
		line-height: 40px;

		span {
			color: #FF3B3B;
		}
	}
}
</style>
 